import { Link } from "react-router-dom";

export const Logo = ({ size = "md" }) => {
  const iconSize = size === "lg" ? 32 : 22;
  const textSize = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <Link
      to="/"
      data-testid="brand-logo-link"
      className="flex items-center gap-3 group"
    >
      <span
        aria-hidden="true"
        className="relative flex items-center justify-center"
        style={{ width: iconSize, height: iconSize }}
      >
        <svg
          viewBox="0 0 32 32"
          width={iconSize}
          height={iconSize}
          className="text-brand-olive transition-transform duration-500 group-hover:rotate-[-6deg]"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 22 L13 11 L18 17 L27 7" />
          <circle cx="5" cy="22" r="1.8" fill="currentColor" stroke="none" />
          <circle cx="27" cy="7" r="1.8" fill="currentColor" stroke="none" />
        </svg>
      </span>
      <span
        className={`font-display ${textSize} font-light tracking-tight text-brand-deep`}
      >
        Ingredient
        <span className="text-brand-olive">Signal</span>
      </span>
    </Link>
  );
};

export default Logo;
